import React from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import PropTypes from 'prop-types';
import { createTheme } from '@material-ui/core/styles';

/* MobileIdentifier is a higher order component to detect screen size */
const MobileIdentifier = function MobileIdentifier(Component) {
    const WrappedComponent = function WrappedComponent(props) {
        let { isMobile, isSmallScreen } = props;

        // change the default breakpoint's value
        // mobile size should be [0px,768px)
        // small screen size should be [768px,1280px)
        // large screen size should be [1280px,∞)
        const theme = createTheme({
            breakpoints: {
                values: {
                    xs: 0,
                    sm: 600,
                    md: 768,
                    lg: 1280,
                    xl: 1920,
                },
            },
        });

        // disable React Server-Side Rendering (SSR) https://github.com/mui-org/material-ui/issues/21048
        // SSR causes a double render with an intended false negative on the first
        // and then the true value. This may impact positioning elements.
        isMobile = isMobile || useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });
        isSmallScreen = isSmallScreen || useMediaQuery(theme.breakpoints.only('md'), { noSsr: true });

        return (
            <Component {...props} isMobile={isMobile} isSmallScreen={isSmallScreen} />
        );
    };

    WrappedComponent.propTypes = {
        isMobile: PropTypes.bool,
        isSmallScreen: PropTypes.bool,
    };

    WrappedComponent.defaultProps = {
        isMobile: false,
        isSmallScreen: false,
    };

    return WrappedComponent;
};

export default MobileIdentifier;
